<template>
  <div class="ideas-shopping-page">
    <button type="button" class="back-button" @click="$router.push({ name: 'meal-ideas' })">← Retour à ma sélection</button>
    <div class="shopping-header">
      <div class="kicker">MES COURSES</div>
      <h1>Ma liste de courses</h1>
      <p>Calculée uniquement à partir des plats que j’ai sélectionnés.</p>
    </div>

    <div class="source-card">
      <strong>{{ selectedDishCount }} plat{{ selectedDishCount > 1 ? "s" : "" }} sélectionné{{ selectedDishCount > 1 ? "s" : "" }}</strong>
      <span> · {{ checkedCount }}/{{ ingredients.length }} articles pris</span>
    </div>

    <div v-if="!selectedDishCount" class="empty-shopping">
      <strong>Aucun plat sélectionné.</strong>
      <button type="button" @click="$router.push({ name: 'meal-ideas' })">Retourner à mes idées de repas</button>
    </div>
    <div v-else class="shopping-list">
      <label v-for="ingredient in ingredients" :key="ingredient.key" class="shopping-row" :class="{ done: checked.includes(ingredient.key) }">
        <input type="checkbox" :value="ingredient.key" v-model="checked" @change="persistChecked" />
        <span class="name">{{ ingredient.name }}</span>
        <strong>{{ formatQuantity(ingredient.quantity) }} {{ unitLabel(ingredient.unit) }}</strong>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: "MealIdeasShoppingList",
  data() {
    return { selected: { breakfast: [], lunch: [], dinner: [] }, checked: [] };
  },
  computed: {
    selectedDishCount() {
      return Object.values(this.selected || {}).reduce(
        (sum, list) => sum + (Array.isArray(list) ? list.length : 0),
        0
      );
    },
    checkedCount() { return Array.isArray(this.checked) ? this.checked.length : 0; },
    ingredients() {
      const grouped = {};
      Object.values(this.selected || {}).flatMap(list => Array.isArray(list) ? list : []).forEach(recipe => {
        (Array.isArray(recipe?.personalized_ingredients) ? recipe.personalized_ingredients : []).forEach(item => {
          const key = (item.name || "").trim().toLowerCase() + "|" + item.unit;
          if (!grouped[key]) grouped[key] = { key, name: item.name, unit: item.unit, quantity: 0 };
          grouped[key].quantity += Number(item.quantity || 0);
        });
      });
      return Object.values(grouped).sort((a, b) => a.name.localeCompare(b.name, "fr"));
    },
  },
  mounted() {
    try {
      const direct = JSON.parse(localStorage.getItem("mmm-meal-ideas-shopping") || "null");
      if (direct) {
        this.selected = this.normalizeSelection(direct);
      } else {
        const session = JSON.parse(localStorage.getItem("mmm-meal-ideas-session") || "null");
        if (session?.selectedRecipes) this.selected = this.normalizeSelection(session.selectedRecipes);
      }
    } catch (e) {
      this.selected = { breakfast: [], lunch: [], dinner: [] };
    }
    try {
      const persistedChecked = JSON.parse(localStorage.getItem("mmm-ideas-shopping-checked") || "[]");
      this.checked = Array.isArray(persistedChecked) ? persistedChecked : [];
    } catch (e) {
      this.checked = [];
    }
  },
  methods: {
    normalizeSelection(value) {
      const source = value && typeof value === "object" ? value : {};
      return {
        breakfast: Array.isArray(source.breakfast) ? source.breakfast.filter(Boolean) : [],
        lunch: Array.isArray(source.lunch) ? source.lunch.filter(Boolean) : [],
        dinner: Array.isArray(source.dinner) ? source.dinner.filter(Boolean) : [],
      };
    },
    persistChecked() { localStorage.setItem("mmm-ideas-shopping-checked", JSON.stringify(this.checked)); },
    formatQuantity(value) {
      const rounded = Math.round(value * 10) / 10;
      return String(rounded).replace(".", ",");
    },
    unitLabel(unit) { return { piece: "pièce", pincee: "pincée" }[unit] || unit; },
  },
};
</script>

<style scoped>
.ideas-shopping-page { max-width: 980px; margin: 0 auto; padding: 28px 34px 70px; }
.back-button { border: 1px solid #77af24; background: #fff; color: #50731d; border-radius: 10px; padding: 9px 13px; cursor: pointer; font-weight: 700; }
.shopping-header { margin: 20px 0; }
.shopping-header h1 { color: #1d2c13; margin: 4px 0; }
.shopping-header p { color: #65705f; margin: 0; }
.kicker { color: #6d9f25; font-size: 13px; font-weight: 800; letter-spacing: .08em; }
.source-card { background: #f1f8e8; border-radius: 14px; padding: 14px 16px; color: #52604b; margin-bottom: 18px; }
.shopping-list { background: #fff; border-radius: 18px; overflow: hidden; border: 1px solid #e2e7dc; }
.shopping-row { display: grid; grid-template-columns: 30px 1fr auto; gap: 10px; align-items: center; padding: 14px 16px; border-bottom: 1px solid #edf0e8; cursor: pointer; }
.shopping-row:last-child { border-bottom: 0; }
.shopping-row.done .name, .shopping-row.done strong { text-decoration: line-through; opacity: .55; }
.shopping-row input { width: 18px; height: 18px; accent-color: #77af24; }
.empty-shopping { background: #fff; border: 1px solid #e2e7dc; border-radius: 16px; padding: 22px; display: flex; gap: 14px; align-items: center; flex-wrap: wrap; }
.empty-shopping button { border: 1px solid #77af24; background: #77af24; color: white; border-radius: 10px; padding: 9px 12px; cursor: pointer; font-weight: 700; }
@media (max-width: 600px) { .ideas-shopping-page { padding: 20px 16px 60px; } }
</style>
